import { NgxUiLoaderConfig } from "ngx-ui-loader";

export const ToastrConstant = {
  closeButton: true,
  timeOut: 5000,
  positionClass: 'toast-top-right',
  extendedTimeOut: 5000,
  preventDuplicates: true
};

export const SpinnerConfig: NgxUiLoaderConfig = {
  fgsType: 'ball-spin',
  overlayColor: 'rgba(255,255,255,0.5)',
  fgsSize: 40,
  hasProgressBar: false
}

export const MaterialTableConfig = {
  pageSizeOptions: [5, 10, 20],
  defaultPageSize: 10,
  firstPage: 0
}

export const Roles = {
  admin: 'Admin'
} as const;

export const EulaStatusValues = {
  accepted: 'Accepted',
  pending: 'Pending'
} as const;

export const EulaStatusClass = {
  accepted: 'status-accepted',
  pending: 'status-pending'
} as const;

export const ErrorMessages = {
  unauthorized: 'Unauthorized Access',
  forbidden: 'Forbidden Access',
  permissionsChanged: 'Your permissions have been updated. Redirecting to home page.'
} as const;
